import React from "react";

const Profile = ({ user, type, earnedPoints }) => {
  return (
    <>
      <input type="text" disabled={true} value={user} />
      <input type="text" disabled={true} value={type} />
      <input
        type="text"
        disabled={true}
        value={`Total points: ${earnedPoints}`}
      />
    </>
  );
};

export default Profile;
